import { render, staticRenderFns } from "./manage-tri-urgence.html?vue&type=template&id=10d37f90&scoped=true&external"
import script from "./manage-tri-urgence.js?vue&type=script&lang=js&external"
export * from "./manage-tri-urgence.js?vue&type=script&lang=js&external"
import style0 from "./manage-tri-urgence.scss?vue&type=style&index=0&id=10d37f90&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d37f90",
  null
  
)

export default component.exports